export const configLocal = {
  clientId: "68cfa822-5ad2-4813-accd-ea78b595f2b4",
  authority:
    "https://login.microsoftonline.com/2f0e80a6-80a9-4c92-8401-b2711c15efdc/v2.0",
  postLogoutRedirectUri: "http://localhost:3000/auth",
  redirectUri: "http://localhost:3000/auth",
  scopes: ["https://api.dev.ams.aurora.io/TENANT_giacom2"],
  apiUrl: "http://localhost:8080/v1",
};
